import { NavBar } from '../components/NavBar'
import { Footer } from '../components/Footer'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import client from '../client.js'
import imageUrlBuilder from '@sanity/image-url'
import { Hero2022 } from '../sections/homeHero/2022'
import { Hero2023 } from '../sections/homeHero/2023'
import { Hero2024 } from '../sections/homeHero/2024'
import { Hero2025 } from '../sections/homeHero/2025'
import { motion } from 'motion/react'
import { transform } from 'valibot'
import { useNavigate, useLoaderData } from 'react-router-dom'

const builder = imageUrlBuilder(client)

function urlFor(source) {
  return builder.image(source)
}

export const Home = ({ year = 2024 }) => {
  const navigate = useNavigate()
  const homeData = useLoaderData()
  const [allPostsData, setAllPosts] = useState(homeData || null)

  useEffect(() => {
    client
      .fetch(
        `*[_type == "story" && year == "${year}"] | order(order asc){
          title,
          slug,
          mainImage {
            ..., // this will ensure you keep the existing data
            ...asset-> {
              altText,
              caption,
              ...metadata {
                lqip, // the lqip can be used for blurHashUrl or other low-quality placeholders
                ...dimensions {
                  width,
                  height
                }
              }
            }
          },
          "mainImageHotSpot": mainImage.hotspot,
          cardImage {
            ..., // this will ensure you keep the existing data
            ...asset-> {
              altText,
              caption,
              ...metadata {
                lqip, // the lqip can be used for blurHashUrl or other low-quality placeholders
                ...dimensions {
                  width,
                  height
                }
              }
            }
          },
          firstByline,
          iconColor,
          seoDescription,
          timeToRead,
        }
      `
      )
      .then((data) => {
        setAllPosts(data)
      })
      .catch(console.error)
  }, [year])

  return (
    <>
      <NavBar year={year} />
      <div className="mx-auto blur-0">
        {year === 2022 && <Hero2022 />}
        {year === 2023 && <Hero2023 />}
        {year === 2024 && <Hero2024 />}
        {year === 2025 && <Hero2025 />}

        {year === 2025 && (
          <div className="relative z-10 mx-auto max-w-7xl bg-white pb-20 lg:pb-28 xl:px-8 ">
            <div class="relative mx-auto h-auto w-full max-w-[--container-max-w] px-[--container-p] [--container-max-w:theme(maxWidth.4xl)] [--container-p:theme(spacing.6)] sm:[--container-p:theme(spacing.12)] lg:[--container-max-w:theme(maxWidth.5xl)] 2xl:[--container-max-w:theme(maxWidth.7xl)]">
              <div class="flex flex-col gap-16 sm:gap-0">
                {!allPostsData && <div className="min-h-[5000px]"></div>}
                {allPostsData &&
                  allPostsData.map((post, index) => (
                    <div
                      key={post.slug.current}
                      // initial={{
                      //   opacity: 0,
                      //   filter: 'blur(20px)',
                      //   transform: 'translateY(20px)',
                      // }}
                      // whileInView={{
                      //   opacity: 1,
                      //   filter: 'blur(0px)',
                      //   transform: 'translateY(0px)',
                      // }}
                      // viewport={{
                      //   once: true,
                      //   amount: 0,
                      // }}
                      // transition={{ duration: 0.5 }}
                      className={
                        `group relative flex w-full flex-col ` +
                        (index % 2 === 0
                          ? 'sm:flex-row-reverse'
                          : 'sm:flex-row')
                      }
                    >
                      <div
                        className={`group flex transform flex-col border-none  shadow-sm outline-none transition-all duration-500 visited:opacity-50 hover:rounded-none hover:opacity-100 focus:-translate-y-1 focus:rounded-none motion-reduce:transition-none sm:w-1/2`}
                        style={{
                          filter: 'blur(0px)',
                        }}
                      >
                        <Link
                          class="relative h-full min-h-[16rem] flex-shrink-0 sm:min-h-[18rem] lg:min-h-[24rem]"
                          to={post?.slug?.current}
                          unstable_viewTransition
                          tabindex="-1"
                        >
                          {post?.mainImage ? (
                            <img
                              className={
                                post?.slug.current +
                                ` story absolute inset-0 h-full w-full object-cover ` +
                                (index % 2 === 0
                                  ? 'origin-left'
                                  : 'origin-right')
                              }
                              src={urlFor(post?.mainImage).width(1920).url()}
                              alt={post?.mainImage?.altText}
                              style={{
                                viewTransitionName: post?.slug.current
                                  ? `${post.slug.current}-image`
                                  : '',
                              }}
                            />
                          ) : (
                            <div class="h-72 w-full transform object-cover opacity-100 filter transition-all duration-500 group-hover:-translate-y-12 group-hover:scale-105 group-hover:grayscale-0 group-focus:-translate-y-12 group-focus:scale-105 group-focus:grayscale-0 md:h-96"></div>
                          )}
                        </Link>
                        <div class="pointer-events-none absolute bottom-0 w-full translate-y-[70px] transform transition-all duration-500 group-hover:translate-y-0 group-focus:translate-y-0">
                          <div class="flex flex-1 flex-col justify-between bg-transparent p-6">
                            <div class="flex-1">
                              {/* <div class="mx-auto mt-2 block max-w-[40ch] text-center">
                                <p class="text-xl font-semibold text-white">
                                  {post?.title}
                                </p>
                                <p class="mt-3 text-base text-neutral-100 line-clamp-3">
                                  {post?.seoDescription}
                                </p>
                              </div> */}
                            </div>
                          </div>
                          {/* <div class="flex items-center bg-neutral-50 p-6">
                            <div class="flex w-full justify-between">
                              <p class="truncate text-sm font-medium text-neutral-900">
                                <span class="hover:underline ">
                                  {post.firstByline}
                                </span>
                              </p>
                              {post?.timeToRead && (
                                <div class="flex flex-shrink-0 space-x-1 whitespace-nowrap text-sm text-neutral-500">
                                  <span>{post.timeToRead} min read </span>
                                </div>
                              )}
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <div
                        className={
                          `flex flex-col items-start justify-center p-8 sm:w-1/2 xl:py-8 ` +
                          (index % 2 === 0 ? 'sm:items-end' : '')
                        }
                      >
                        <div
                          class={
                            `mt-2 flex flex-col items-start text-left ` +
                            (index % 2 === 0
                              ? 'sm:items-end sm:text-right'
                              : '')
                          }
                        >
                          <Link
                            className={`font-condensed text-2xl font-bold uppercase leading-tight text-neutral-700 hover:underline sm:text-3xl lg:text-5xl`}
                            to={post?.slug?.current}
                            unstable_viewTransition
                            style={{
                              viewTransitionName:
                                post?.slug.current.toString() + '-title',
                            }}
                          >
                            {post?.title}
                          </Link>
                          <p class="mt-3 font-display text-sm text-[#9D908C] line-clamp-3 sm:max-w-[40ch] lg:text-base">
                            {post?.seoDescription}
                          </p>
                          <span class="mt-3 inline-flex items-center rounded-md bg-neutral-50 px-2 py-1 text-xs font-medium text-neutral-600 ring-1 ring-inset ring-neutral-500/10">
                            {post?.timeToRead} min read
                          </span>
                        </div>
                      </div>

                      {/* <div
                        className={
                          `pointer-events-none absolute top-0 h-full w-[calc(calc(calc(theme(width.screen)-var(--container-max-w))/2)+var(--container-p))] min-w-[--container-p] from-sv-light-blue/70 to-sv-light-blue/50 group-odd:bg-gradient-to-r group-even:bg-gradient-to-l  ` +
                          (index % 2 === 0 ? 'left-full' : 'right-full')
                        }
                      ></div> */}
                      {/* {post?.mainImage ? (
                        <div
                          className={
                            `pointer-events-none absolute top-0 h-full w-[calc(calc(calc(theme(width.screen)-var(--container-max-w))/2)+var(--container-p))] min-w-[--container-p]  overflow-hidden ` +
                            (index % 2 === 0 ? 'right-full' : 'left-full')
                          }
                        >
                          <img
                            className={
                              post?.slug.current +
                              ` absolute inset-y-0 left-0 h-full w-full scale-[125%] object-cover ` +
                              (index % 2 === 0 ? 'origin-right' : 'origin-left')
                            }
                            src={
                              post?.cardImage
                                ? urlFor(post?.cardImage)?.width(800).url()
                                : urlFor(post?.mainImage)?.width(800).url()
                            }
                            alt=""
                            style={{
                              objectPosition: `${post?.mainImageHotSpot?.x * 100}% ${post?.mainImageHotSpot?.y * 100}%`,
                            }}
                          />
                        </div>
                      ) : (
                        <div></div>
                      )} */}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {year !== 2025 && (
          <div class="relative z-10 bg-white px-4 pt-16 pb-20 sm:px-6 lg:px-8 lg:pt-24 lg:pb-28">
            <div class="relative mx-auto -mt-48 max-w-7xl lg:-mt-72">
              <div class="mx-auto mt-12 grid max-w-[26rem] gap-8 sm:max-w-[54rem] sm:grid-cols-2 lg:max-w-none lg:grid-cols-3">
                {allPostsData &&
                  allPostsData.map((post, index) => (
                    <Link
                      to={post?.slug?.current}
                      className={`group flex transform flex-col overflow-hidden rounded-3xl border-none shadow-sm outline-none transition-all duration-500 visited:opacity-50 hover:-translate-y-1 hover:rounded-none hover:opacity-100 hover:shadow-2xl focus:-translate-y-1 focus:rounded-none focus:shadow-2xl motion-reduce:transition-none [&:nth-child(6n+1)]:hover:shadow-sv-navy/40 [&:nth-child(6n+2)]:hover:shadow-sv-green/50 [&:nth-child(6n+3)]:hover:shadow-sv-yellow/70 [&:nth-child(6n+4)]:hover:shadow-sv-orange/50 [&:nth-child(6n+5)]:hover:shadow-sv-light-blue/50 [&:nth-child(6n)]:hover:shadow-sv-crimson/40`}
                      style={{
                        filter: 'blur(0px)',
                      }}
                    >
                      <div class="relative flex-shrink-0 overflow-hidden">
                        {post?.mainImage ? (
                          <img
                            class="h-72 w-full transform object-cover opacity-100 filter transition-all duration-500 group-hover:-translate-y-12 group-hover:scale-105 group-hover:grayscale-0 group-focus:-translate-y-12 group-focus:scale-105 group-focus:grayscale-0 md:h-96"
                            src={
                              post?.cardImage
                                ? urlFor(post?.cardImage)
                                    ?.width(800)
                                    .height(505)
                                    .url()
                                : urlFor(post?.mainImage)
                                    ?.width(800)
                                    .height(505)
                                    .url()
                            }
                            alt={post?.mainImage?.altText}
                            style={{
                              objectPosition: `${post?.mainImageHotSpot?.x * 100}% ${post?.mainImageHotSpot?.y * 100}%`,
                            }}
                          />
                        ) : (
                          <div class="h-72 w-full transform object-cover opacity-100 filter transition-all duration-500 group-hover:-translate-y-12 group-hover:scale-105 group-hover:grayscale-0 group-focus:-translate-y-12 group-focus:scale-105 group-focus:grayscale-0 md:h-96"></div>
                        )}
                        <div class="absolute left-0 right-0 bottom-0 h-full bg-gradient-to-t from-black to-transparent opacity-70 transition-all duration-500 group-hover:h-full group-hover:opacity-100"></div>
                      </div>
                      <div class="pointer-events-none absolute bottom-0 w-full translate-y-[70px] transform transition-all duration-500 group-hover:translate-y-0 group-focus:translate-y-0">
                        <div class="flex flex-1 flex-col justify-between bg-transparent p-6">
                          <div class="flex-1">
                            <div class="mt-2 block">
                              <p class="text-xl font-semibold text-white">
                                {post?.title}
                              </p>
                              <p class="mt-3 text-base text-neutral-100 line-clamp-3">
                                {post?.seoDescription}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="flex items-center bg-neutral-50 p-6">
                          <div class="flex w-full justify-between">
                            <p class="truncate text-sm font-medium text-neutral-900">
                              <span class="hover:underline ">
                                {post.firstByline}
                              </span>
                            </p>
                            {post?.timeToRead && (
                              <div class="flex flex-shrink-0 space-x-1 whitespace-nowrap text-sm text-neutral-500">
                                <span>{post.timeToRead} min read </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  )
}
